import { useTranslation } from "react-i18next";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import { useEffect, useState } from "react";
import { FI_CLOSING_AUTH, FI_DIRECTOR_AUTH, FinancialMenuType } from "../../../constans";
import TabItem from "../../../components/statistics/TabItem";
import IncomeList from "../../../components/payment/financial/income/List";
import ExpenseList from "../../../components/payment/financial/expense/List";
import ExpApprovalList from "../../../components/payment/financial/expense-approval/List";
import IncomeExpenseList from "../../../components/payment/financial/income-expense/List";
import CashFlowList from "../../../components/payment/financial/cash-flow/List";
import ExceptionList from "../../../components/payment/financial/exception/List";
import ClosingList from "../../../components/payment/financial/closing/List";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { doGetTreeCodes } from "../../../store/treeCodeData.slice";
import { useHistory, useLocation } from "react-router-dom";
import QueryString from "qs";
import { ConfigProvider } from "antd";
import koKR from 'antd/lib/locale/ko_KR';
import enUS from 'antd/lib/locale/en_US';

const FinancialManagement = () => {
    
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
    const [tabStatus, setTabStatus] = useState(FinancialMenuType.INCOME); 
    const { auth } = useSelector((state: RootState) => state.auth);
    const [isRender1, setIsRender1] = useState(false);
    const [isRender2, setIsRender2] = useState(false);
    const { treeCodes } = useSelector((state: RootState) => state.treeCodeData);
    const [params, setParams] = useState();

    //수입/지출 진입 전 treeCode reducer 셋팅
    useEffect(() => {
        if (auth.memberCode && auth.campus) {
            dispatch(doGetTreeCodes());
            setIsRender1(true);
        }
    },[auth]);

    useEffect(() => {
        if(isRender1 && treeCodes.length > 0) {
            setIsRender2(true);
        }
    }, [treeCodes]);

    useEffect(() => {
        const _params: any = {};
        
        if (query.type) {
          _params.type = Number(query.type);
          setTabStatus(_params.type);
        }

        setParams(_params);
      }, [location]);

    const onSetTabStatus = (_content: FinancialMenuType) => {
        setTabStatus(_content);
        let _params: any = {};
        if (params) {
          // @ts-ignore
          _params = { ...params, type: _content };
        }
        history.push(`/payment/financial?${QueryString.stringify(_params)}`);
    };

    const renderContent = () => {
        switch (tabStatus) {
            case FinancialMenuType.INCOME:
                return <IncomeList />;
            case FinancialMenuType.EXPENSE:
                return <ExpenseList />;
            case FinancialMenuType.EXPENSE_APPROVAL:
                return <ExpApprovalList />;
            case FinancialMenuType.INCOME_EXPENSE:
                return <IncomeExpenseList />;
            case FinancialMenuType.CASH_FLOW:
                return <CashFlowList />;
            case FinancialMenuType.EXCEPTION:
                return <ExceptionList />;
            case FinancialMenuType.CLOSING:
                return <ClosingList />;
            default:
                return <IncomeList />;
        }
    };

    return (
        <ConfigProvider 
            locale={i18n.language === 'ko' ? koKR : enUS}
            getPopupContainer={node => {
                if (node) {
                  return node.parentNode as HTMLElement;
                }
                return document.body as HTMLElement;
            }}
        >
        <SimpleHeader
            iconFile="icon-payment-big.svg"
            parentMenu={t('common.menu.payment')}
            currentMenu={t('payment.income.title2')}
            onlyTitle={true}
        />
        <div className="content scrollbar">
            {/* tab 영역 */}
            <div className="col-frame">
                <div className="comm-tab__line">
                    <ul>
                        <TabItem
                            currentContent={tabStatus}
                            onSetContent={onSetTabStatus}
                            tabContent={FinancialMenuType.INCOME}
                            tabLabel={t('payment.income.tab1')}
                        />
                        <TabItem
                            currentContent={tabStatus}
                            onSetContent={onSetTabStatus}
                            tabContent={FinancialMenuType.EXPENSE}
                            tabLabel={t('payment.income.tab2')}
                        />
                        <TabItem
                            currentContent={tabStatus}
                            onSetContent={onSetTabStatus}
                            tabContent={FinancialMenuType.EXPENSE_APPROVAL}
                            tabLabel={t('payment.income.tab3')}
                        />
                        {   
                            /* 대표원장 1001, 원장 1002 권한 처리 */
                            (auth.hqYn === 'Y' || FI_DIRECTOR_AUTH.includes(auth.groupNo)) &&
                            (
                            <>
                                <TabItem
                                    currentContent={tabStatus}
                                    onSetContent={onSetTabStatus}
                                    tabContent={FinancialMenuType.INCOME_EXPENSE}
                                    tabLabel={t('payment.income.tab4')}
                                />
                                <TabItem
                                    currentContent={tabStatus}
                                    onSetContent={onSetTabStatus}
                                    tabContent={FinancialMenuType.CASH_FLOW}
                                    tabLabel={t('payment.income.tab5')}
                                />
                                <TabItem
                                    currentContent={tabStatus}
                                    onSetContent={onSetTabStatus}
                                    tabContent={FinancialMenuType.EXCEPTION}
                                    tabLabel={t('payment.income.tab6')}
                                />   
                            </>
                            )
                        }
                        {
                             /* 대표원장, 원장, 상담팀장, 상담매니저 권한 처리 */
                            (auth.hqYn === 'Y' || FI_CLOSING_AUTH.includes(auth.groupNo)) &&
                            (
                                <TabItem
                                    currentContent={tabStatus}
                                    onSetContent={onSetTabStatus}
                                    tabContent={FinancialMenuType.CLOSING}
                                    tabLabel={t('payment.income.tab7')}
                                />
                            )
                        }
                    </ul>
                </div>
                <div>
                    {/* contents 영역 */}
                    {isRender2 && renderContent()}
                </div>
            </div>
        </div>
        </ConfigProvider>
    )
}

export default FinancialManagement;